"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useCirrusSocketConnectionStatus = void 0;
const react_1 = require("react");
const useCirrus_1 = require("./useCirrus");
function useCirrusSocketConnectionStatus() {
    const { socket } = useCirrus_1.useCirrus();
    const [connected, setConnected] = react_1.useState(false);
    const [error, setError] = react_1.useState(null);
    react_1.useEffect(() => {
        setError(null);
        const handler = (e) => {
            setError(e !== null && e !== void 0 ? e : 'Connection error');
        };
        socket.addEventListener('error', handler);
        const closeHandler = (e) => {
            setError(e !== null && e !== void 0 ? e : 'Connection closed');
        };
        socket.addEventListener('close', closeHandler);
        return () => {
            socket.removeEventListener('error', handler);
            socket.removeEventListener('close', closeHandler);
        };
    }, [socket]);
    react_1.useEffect(() => {
        setConnected(false);
        const abortController = new AbortController();
        socket.open().then(() => {
            if (!abortController.signal.aborted) {
                setConnected(true);
            }
        });
        return () => {
            abortController.abort();
        };
    }, [socket]);
    react_1.useEffect(() => {
        const onClose = () => {
            setConnected(false);
        };
        socket.addEventListener('close', onClose);
        return () => {
            socket.removeEventListener('close', onClose);
        };
    }, [socket]);
    return react_1.useMemo(() => connected
        ? { type: 'connected' }
        : error
            ? { type: 'error', error }
            : { type: 'disconnected' }, [connected, error]);
}
exports.useCirrusSocketConnectionStatus = useCirrusSocketConnectionStatus;
//# sourceMappingURL=useCirrusSocketConnectionStatus.js.map